import { DynaDocsResponse } from './dac.types';
import { WithMetadata } from './generic-responses.types';
import { Paa } from './paa.types';
import { Ppm } from './ppm.types';

export interface Tasks {
  tenantId: string;
  tasks: Task[];
  candidateGroup: string;
  status: string;
}

export enum TasksStatus {
  BROUILLON = 'BROUILLON',
  EN_TRAITEMENT = 'EN_TRAITEMENT',
  VALIDE = 'VALIDE',
  PUBLIEE = 'PUBLIE',
}

export enum CandidateGroup {}

export interface FlowableProcess {
  processInstanceId: string;
  processDefinitionId: string;
  taskId: string;
  status: string;
}

export interface Traceability {
  dateComment: string;
  decision: string;
  comment: string;
  treater: string;
}

export interface Task {
  taskId: string;
  taskName: string;
  taskDefinitionKey: string;
  assignee: string;
  processInstanceId: string;
  processDefinitionId: string;
  candidateGroup: string | CandidateGroup;
  traceability: Traceability;
  id: string;
  version: number;
  ref?: string;
  nomAc: string;
  newStatus: string | null;
  validate: boolean | null;
  status: string | null;
  isUpdatable: boolean;
  isPublishable: boolean;
  commissionRequired?: boolean;
  meetingRequired?: null;
  assignRapporteur?: boolean;
}

export interface NextStep {
  validationVariable: string;
  validationValue: string;
  nextTaskName: string;
  actionLabel: string;
}

export interface TaskDetails {
  taskId: string;
  taskName: string;
  taskDefinitionKey: string;
  assignee: string;
  processInstanceId: string;
  created: string;
  candidateGroup: string;
  traceability: Traceability;
  status: string;
  isUpdatable: boolean;
  isPublishable: boolean;
  nextSteps: NextStep[];
}

export interface PaaTaskDetails extends TaskDetails {
  paa: WithMetadata<Paa>;
}

export interface DacTaskDetails extends TaskDetails {
  dac: DynaDocsResponse;
}
export interface PpmTaskDetails extends TaskDetails {
  ppm: WithMetadata<Ppm>;
  comId: number;
}

export interface TaskHistory {
  id: string;
  name: string;
  assignee: string;
  startDate: Date;
  endDate: Date;
  observation: string;
  concern: string;
  comment: string;
  current: boolean;
}
